module.exports = __webpack_public_path__ + "img/financial-accounting-bg.78485ffa.png";